import floatingGhostImage from "@/assets/staffer-pets/accessories/floating-ghost.png";
import { Column } from "@/components/Column";

// The pet shop's ghost drifts across the yard after dark, then fades out
// until its next pass. Drawn above the night tint so it glows.
export const PlayyardDriftingGhost = () => {
  return (
    <Column className="staffer-pet-yard-ghost-drift pointer-events-none absolute left-[8%] top-[40%] z-[41]">
      <img
        src={floatingGhostImage}
        alt=""
        className="staffer-pet-yard-bob w-[7cqw] [filter:drop-shadow(0_0_10px_rgb(210_200_255_/_0.75))] [image-rendering:pixelated]"
      />
    </Column>
  );
};
